import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD-O-4xe5Zg6xo4klI057iNjp1Emoz7eu0",
  authDomain: "leveladvisedatabase.firebaseapp.com",
  projectId: "leveladvisedatabase",
  storageBucket: "leveladvisedatabase.appspot.com",
  messagingSenderId: "513344773612",
  appId: "1:513344773612:web:1053809ac7c2b01bc1f4c9",
  measurementId: "G-BFYZFKQCCK",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);